import TalentCard from './TalentCard'

export default TalentCard
